import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { z } from "zod";

const donateNowSearchSchema = z.object({
  tab: z.string().optional(),
  source: z.string().optional(),
});

export const Route = createFileRoute("/$lang/donate-now")({
  component: React.lazy(() =>
    import("@/pages/donate-now").then((module) => ({ default: module.DonateNow })),
  ),
  validateSearch: (search) => donateNowSearchSchema.parse(search),
});
